import { initialize } from 'redux-form';
import {
  GET_LISTING_DATA_STEP2_START,
  GET_LISTING_DATA_STEP2_SUCCESS,
  GET_LISTING_DATA_STEP2_ERROR
} from '../constants';
import { userListingStepTwo as query } from '../lib/graphql';
import { formatLocaleData } from '../helpers/formatLocale';

export const getListingDataStep2 = (listId) => {
  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: GET_LISTING_DATA_STEP2_START,
      });
      const activeLanguageCodes = getState()?.runtime?.isActiveLanguages?.map(item =>
        formatLocaleData(item)
      );
      // Send Request to get listing data
      const { data } = await client.query({
        query,
        variables: { listId: Number(listId), preview: true },
        fetchPolicy: 'network-only',
      });

      if (data?.UserListing) {
        // Reinitialize the form values
        let result = { ...data.UserListing };

        if (result?.dynamicListTitle?.length <= 0) {
          result = { ...result, dynamicListTitle: [{ listTitle: result?.title, language: 'en' }] };
        }
        if (result?.dynamicListDescription?.length <= 0) {
          result = { ...result, dynamicListDescription: [{ listDescription: result?.description, language: 'en' }] };
        }

        result.dynamicListTitleDescription = result.dynamicListTitle.map(titleItem => {
          const descItem = result.dynamicListDescription.find(d => d.language === titleItem.language);
          console.log("titleItem",titleItem)
          const isActive = activeLanguageCodes?.includes(titleItem.language);
          return {
            language: isActive ? titleItem.language : '',
            listTitle: titleItem.listTitle,
            listDescription: descItem ? descItem.listDescription : ''
          };
        });
        await dispatch(initialize('ListPlaceStep2', result, true));

        // Dispatch a success action
        dispatch({
          type: GET_LISTING_DATA_STEP2_SUCCESS,
          step2DataIsLoaded: true,
          isExistingList: true,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_LISTING_DATA_STEP2_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }
    return true;
  };
}
